<template>
  <div>
    <div class="container-fluid">
      <form v-on:submit.prevent>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">
            Merchant Name
            <sup>*</sup>
          </label>
          <div class="col-sm-7 pr-5">
            
            <input
              v-on:keydown.enter.prevent
              type="text"
              name="merchant_id"
              v-model="seller.merchant_new"
              class="form-control"
              id="merchant_id"
              placeholder="Merchant name"
              autocomplete="off"
              v-on:input="addNewMerchant($event)"
            />
            <span
              class="no-data-style"
              v-if="
                seller &&
                seller.merchant_name &&
                !seller.merchant_name.merchant_name &&
                isSubmitted
              "
            >
              Provide the required field
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">
            Merchant Id
            <sup>*</sup>
          </label>
          <div class="col-sm-7 pr-5">
            <input
              v-on:keydown.enter.prevent
              type="text"
              name="merchant_id"
              v-model="seller.merchant_id"
              class="form-control"
              id="merchant_id"
              placeholder="Merchant id"
              autocomplete="off"
              v-on:input="checkDuplicasyId($event)"
            />
            <span
              class="no-data-style"
              v-if="
                seller &&
                (!seller.merchant_id ||
                  seller.merchant_id == undefined ||
                  seller.merchant_id == '') &&
                isSubmitted
              "
            >
              Provide the required field
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">
            Country
            <sup>*</sup>
          </label>
          <div class="col-sm-7 pr-5">
            <multiselect
              v-model="seller.country_code"
              :options="countryList"
              label="market_place"
              :searchable="true"
              ref="multiselect"
              track-by="country_code"
              open-direction="bottom"
              placeholder="Country"
              class="form-control multi-dropdown select_filter"
              selectLabel=""
              deselectLabel=""
              selectedLabel=""
              tagPlaceholder=""
              autocomplete="off"
              style="max-height: 40px"
              :multiple="false"
              id="country_code"
              :taggable="false"
            />
            <span
              class="no-data-style"
              v-if="
                seller &&
                (!seller.country_code ||
                  seller.country_code == undefined ||
                  seller.country_code == '') &&
                isSubmitted
              "
            >
              Provide the required field
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label"> Seller Auth Dev Token </label>
          <div class="col-sm-7 pr-5">
            <input
              v-on:keydown.enter.prevent
              type="text"
              name="entityId"
              v-model="seller.seller_dev_auth_token"
              class="form-control"
              id="entityId"
              placeholder="Seller dev auth token"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="form-group row" style="height:30px">
          <label class="col-sm-3 col-form-label"> </label>
          <div class="col-sm-7 pr-5">
            <p class="no-data-style" v-if="alreadyExistName">
              Merchant with same name already exists, please assign different
              merchant name
            </p>
            <p class="no-data-style" v-if="alreadyExistId">
              Merchant with same id already exists, please assign different
              merchant id
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  name: "SellerData",
  components: { Multiselect, moment, datePicker },
  props: ["seller", "countryList", "sellerList", "disableMechantName"],
  data() {
    return {
      alreadyExistId: false,
      alreadyExistName:false,
      isSubmitted: false,
    };
  },
  mounted() {},
  methods: {
    addNewMerchant(val) {
      let data = val.currentTarget.value;

      if (data && data.trim().length) {
        //	  this.alreadyExistId = false
        let existingSeller = this.sellerList.find(
          (e) =>
            e.merchant_name.toLowerCase().trim() == data.toLowerCase().trim()
        );
      //   if (eventData.currentTarget.value.trim().length) {
      //   this.alreadyExistName = false;
      //   this.isSubmitted = false;
      //   let existingName = this.sellerList.find(
      //     (e)=>
      //     this.seller.merchant_name.toLowerCase().trim() == e.merchant_name.toLowerCase().trim()
      //   )
      //   if(existingName){
      //     this.alreadyExistName = true;
      //   }
      // } else {
      //   eventData.currentTarget.value = eventData.currentTarget.value.trim();
      //   this.seller.merchant_name = this.seller.merchant_name.trim();
      // }
      
        if (existingSeller) {
          // this.seller.merchant_id = data.merchant_id;
          // this.seller.id = '';
          // let country = this.countryList.find((e) => e.country_code == data.country_code);
          // this.seller.country_code = country
          // this.seller.seller_dev_auth_token = data.seller_dev_auth_token;
          // this.seller.merchant_name = {merchant_name:existingSeller.merchant_name, merchant_id:existingSeller.merchant_id}
          //  this.alreadyExistId = true
          this.alreadyExistName = true;
          let obj = {
            merchant_name: data,
          };
          this.seller.merchant_name = obj;
        } else {
          this.alreadyExistName = false;
          let obj = {
            merchant_name: data,
          };
          this.seller.merchant_name = obj;
          //  this.alreadyExistId = false
          //  this.sellerList.push(obj)
        }
      } else {
        val.currentTarget.value = val.currentTarget.value.trim();
        this.seller.merchant_new = this.seller.merchant_new.trim();
        let obj = {
            merchant_name: val.currentTarget.value,
          };
          this.seller.merchant_name = obj;
      }
    },
    checkDuplicasyId(eventData) {
      eventData.currentTarget.value = eventData.currentTarget.value.trim();
      this.seller.merchant_id = this.seller.merchant_id.trim();
    },
    selectMerchant(data) {
      this.seller.merchant_id = data.merchant_id;
      this.seller.id = "";
      let country = this.countryList.find(
        (e) => e.country_code == data.country_code
      );
      this.seller.country_code = country;
      this.seller.seller_dev_auth_token = data.seller_dev_auth_token;

      this.alreadyExistId = true;
      this.alreadyExistName = true;
    },
    resetValue(val) {
      this.alreadyExistId = val;
      this.alreadyExistName = val;
    },
    unselectMerchant() {
      this.seller = {};
      this.alreadyExistId = false;
      this.alreadyExistName = false;
    },
    validate(val) {
      this.isSubmitted = val;
    },
  },
};
</script>
